module.exports = __webpack_public_path__ + "static/media/butter-robot-image-3.f606bb04.jpg";